import React from "react";
import { FaFootballBall } from "react-icons/fa";
import websitelogo from "../../Assets/projectlogo.jpg";
import "./Loader.css";

const Loader = () => {
  return (
    // <div className="loader-container">
    <div className="loader-main-div">
      <div className="loader-second-div">
        <div className="loader">
          <img src={websitelogo} alt="Logo" className="websitelogo" />
          {/* <FaFootballBall className="football-icon" /> */}
        </div>
      </div>
      {/* <p>Loading Football Stats...</p> */}
    </div>
  );
};
export default Loader;
